import { getInfoByMonth } from '@pages/WorkSchedule/utils';

import { months } from '@pages/WorkSchedule/data';
import type { NWorkSchedule } from '@pages/WorkSchedule/WorkSchedule.types';

/**
 * Алгоритм работы функции
 *
 * 1. Получить список дат за 2 года (1 год назад, 1 вперед).
 * 2. Определить количество узлов DOM-дерева на основе месяцев
 * пользователя для рендера.
 * 3. Сформировать массив узлов DOM-дерева (объекты).
 * Максимум – число дат для рендера.
 * 4. Расширить объекты свойством диапазона месяца в px.
 * Учесть эмпирически выявленное смещение сайдбара.
 * 5. Сделать возврат динамических названий месяцев в зависимости
 * от значения текущего положения горизонтального скрола.
 *
 * ДОПОЛНЕНИЕ: можно шаги 3 и 4 сделать как 1,
 * получая шаг смещения из ширины и правого отступа ячейки,
 * но тогда появится завязка на UI.
 */
type MonthCell = {
  date: string;
  firstMonthElement: Element | null;
  lastMonthElement: Element | null;
  range: {
    start: number;
    end: number;
  };
};

export const getScrollingMonth: NWorkSchedule.GetScrollingMonth = ({
  event,
  renderedMonths,
}) => {
  const scrollLeft = event.target?.scrollLeft;

  const cellsOfMonths: Array<MonthCell> = [];
  let result: NWorkSchedule.CurrentMonth = {
    title: '',
    startDate: '',
  };

  // ШАГ 1. Создать массив с пустыми объектами
  (renderedMonths || []).forEach((_, index) => {
    cellsOfMonths[index] = {
      date: '',
      firstMonthElement: null,
      lastMonthElement: null,
      range: {
        start: 0,
        end: 0,
      },
    };
  });

  // ШАГ 2. Получить список узлов DOM-дерева (первых ячеек)
  renderedMonths.map((date: string, index: number) => {
    const firstMonthCellNode = document.querySelector(`.day.date-${date}`);
    // TODO: учесть високосные годы
    const lastDateOfMonth = getInfoByMonth(date).dateE;
    const lastMonthCellNode = document.querySelector(
      `.day.date-${lastDateOfMonth}`
    );

    if (
      firstMonthCellNode &&
      cellsOfMonths[index]?.hasOwnProperty('date') &&
      cellsOfMonths[index]?.hasOwnProperty('firstMonthElement')
    ) {
      cellsOfMonths[index].date = date;
      cellsOfMonths[index].firstMonthElement = firstMonthCellNode;
      cellsOfMonths[index].lastMonthElement = lastMonthCellNode;
    }
  });

  // ШАГ 3. Рассчитать диапазоны месяцев
  (cellsOfMonths || []).forEach(({ firstMonthElement }, index) => {
    const isFirstMonth = index === 0;
    const isLastMonth = index === cellsOfMonths.length - 1;

    if (cellsOfMonths[index]?.hasOwnProperty('range')) {
      const { range } = cellsOfMonths[index];

      if (isFirstMonth && !isLastMonth) {
        if (cellsOfMonths[index + 1]?.hasOwnProperty('range')) {
          range.start = 0;
          return (range.end = (
            cellsOfMonths[index + 1].firstMonthElement as HTMLElement
          )?.offsetLeft);
        }
      } else if (isLastMonth && !isFirstMonth) {
        range.start = (firstMonthElement as HTMLElement)?.offsetLeft;
        return (range.end = (
          cellsOfMonths[index].lastMonthElement as HTMLElement
        )?.offsetLeft);
      } else {
        if (cellsOfMonths[index + 1]?.hasOwnProperty('range')) {
          range.start = (firstMonthElement as HTMLElement)?.offsetLeft;
          return (range.end = (
            cellsOfMonths[index + 1].firstMonthElement as HTMLElement
          )?.offsetLeft);
        }
      }
    }
  });
  // ШАГ 4. Определить названия месяцев для каждого диапазона
  (cellsOfMonths || []).forEach((cell) => {
    const { date } = cell;
    const { start, end } = cell.range;
    if (start <= scrollLeft && scrollLeft < end) {
      const monthId = new Date(date).getMonth();

      let title = months
        .find(({ monthId: _monthId }) => _monthId === monthId)
        ?.monthTitle.toUpperCase() as string;
      // ШАГ 5. Добавить номер года (опционально)
      const currentYear = new Date().getFullYear();
      const year = new Date(date).getFullYear();
      if (currentYear !== year) {
        title += ` ${year}`;
      }
      result = {
        title,
        startDate: getInfoByMonth(date).dateS,
      };
    }
  });
  return result;
};
